import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import Logo from './Logo';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navText = isScrolled
    ? 'text-navy-800 hover:text-navy-600'
    : 'text-white/90 hover:text-white';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 text-white transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg shadow-navy-900/10 py-0'
          : 'bg-navy-900 py-0'
      }`}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        <NavLink to="/" className="z-10">
          <Logo isScrolled={isScrolled} />
        </NavLink>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `text-base font-medium transition-colors relative py-2 ${
                isActive
                  ? 'text-orange-500'
                  : navText
              }`
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              `text-base font-medium transition-colors relative py-2 ${
                isActive
                  ? 'text-orange-500'
                  : navText
              }`
            }
          >
            Over Ons
          </NavLink>
          <NavLink
            to="/services"
            className={({ isActive }) =>
              `text-base font-medium transition-colors relative py-2 ${
                isActive
                  ? 'text-orange-500'
                  : navText
              }`
            }
          >
            Diensten
          </NavLink>
          <NavLink
            to="/projects"
            className={({ isActive }) =>
              `text-base font-medium transition-colors relative py-2 ${
                isActive
                  ? 'text-orange-500'
                  : navText
              }`
            }
          >
            Projecten
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `text-base font-medium transition-colors relative py-2 ${
                isActive
                  ? 'text-orange-500'
                  : navText
              }`
            }
          >
            Contact
          </NavLink>
          <a
            href="tel:0383336549"
            className="flex items-center px-4 py-2 rounded-full bg-orange-500 text-white font-semibold hover:bg-orange-600 transition-all duration-300 shadow-lg shadow-orange-500/20 hover:shadow-xl hover:shadow-orange-500/30 hover:-translate-y-0.5"
          >
            <Phone size={16} className="mr-2" />
            038-3336549
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden z-10 p-2"
          onClick={toggleMenu}
          aria-label="Toggle Menu"
        >
          {isMenuOpen ? (
            <X size={24} className={isScrolled ? 'text-navy-800' : 'text-white'} />
          ) : (
            <Menu size={24} className={isScrolled ? 'text-navy-800' : 'text-white'} />
          )}
        </button>

        {/* Mobile Navigation */}
        <div
          className={`fixed inset-0 bg-navy-900/98 backdrop-blur-md flex flex-col justify-center items-center transition-transform duration-300 ease-in-out md:hidden ${
            isMenuOpen ? 'transform translate-x-0' : 'transform translate-x-full'
          }`}
        >
          <nav className="flex flex-col items-center space-y-8">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `text-xl font-medium transition-colors ${
                  isActive ? 'text-orange-500' : 'text-white/90 hover:text-white'
                }`
              }
              onClick={toggleMenu}
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `text-xl font-medium transition-colors ${
                  isActive ? 'text-orange-500' : 'text-white/90 hover:text-white'
                }`
              }
              onClick={toggleMenu}
            >
              Over Ons
            </NavLink>
            <NavLink
              to="/services"
              className={({ isActive }) =>
                `text-xl font-medium transition-colors ${
                  isActive ? 'text-orange-500' : 'text-white/90 hover:text-white'
                }`
              }
              onClick={toggleMenu}
            >
              Diensten
            </NavLink>
            <NavLink
              to="/projects"
              className={({ isActive }) =>
                `text-xl font-medium transition-colors ${
                  isActive ? 'text-orange-500' : 'text-white/90 hover:text-white'
                }`
              }
              onClick={toggleMenu}
            >
              Projecten
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `text-xl font-medium transition-colors ${
                  isActive ? 'text-orange-500' : 'text-white/90 hover:text-white'
                }`
              }
              onClick={toggleMenu}
            >
              Contact
            </NavLink>
            <a
              href="tel:0383336549"
              className="flex items-center px-6 py-3 rounded-full bg-orange-500 text-white font-semibold hover:bg-orange-600 transition-all duration-300 shadow-lg shadow-orange-500/20"
              onClick={toggleMenu}
            >
              <Phone size={18} className="mr-2" />
              038-3336549
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
